
import { shopifyConst } from '@/hooks/shopify-hooks/useShopifyConst.js';
import { useScrmShopifyFetch,useCustomerApiFetch } from "@/hooks/common/fetch/useFetch";
import { customerFragment } from '@/hooks/shopify-hooks/fragments/b2bCustomer/customerFragment';
import { _CSR_ACCESS_TOKEN, _CSR_IS_B2b,_CSR_TOKEN_REFRESHTOKEN  } from '@/const/shopifyConst.js';
import { useGetStorage } from '@/hooks/common/useStorage';
// const isB2b = localStorage.getItem(_CSR_IS_B2b) === 'true';
const isB2b = useGetStorage(_CSR_IS_B2b) === true;
const { domain, c4aOAuth2State } = shopifyConst;
const c4aOAuth2StateNew = c4aOAuth2State === 'true' ? true : false;
// 判断accessToken 是否过期, 这是判断登录状态是否过期
export const useIsAccessTokenValid = () => {
  // const isB2B = localStorage.getItem(_CSR_IS_B2b);
  // const accessToken = JSON.parse(localStorage.getItem(_CSR_ACCESS_TOKEN));
  const isB2B = useGetStorage(_CSR_IS_B2b)
  const accessToken = useGetStorage(_CSR_ACCESS_TOKEN);
    console.log('已经accessToken.expiresAt66666',accessToken)
  // b2b用户有效期只需存在accessToken即可
  if (isB2B) {
    return accessToken ? true : false;
  } else if (accessToken && accessToken.expiresAt) {
    const expiresAt = Date.parse(accessToken.expiresAt),
      currentDate = Date.now();
    if (expiresAt > currentDate) {
      return true;
    }
  }
  return false;
}

export async function attemptObtainAccessToken(code) {
  const { clientId, storeId, customerRedirectUrl } = shopifyConst;
  // customerRedirectUrl没有配置域名，组装完整redirect_uri
  const redirect_uri = window.location.protocol + '//' + window.location.host + customerRedirectUrl;
  const body = new URLSearchParams();
  body.append('grant_type', 'authorization_code');
  body.append('client_id', clientId);
  body.append(
    'redirect_uri',
    redirect_uri
  );
  body.append('code', code);
  // const codeVerifier = localStorage.getItem('code-verifier');
  const codeVerifier = useGetStorage('code-verifier')

  body.append('code_verifier', codeVerifier);
  const headers = {
    'content-type': 'application/x-www-form-urlencoded',
  }

  const response = await fetch(`https://shopify.com/${storeId}/auth/oauth/token`, {
    method: 'POST',
    headers: headers,
    body,
  });

  const resp = await response.json();

  return resp;
}

export async function attemptAccessTokenExchangeRefToken() {
  const { clientId, storeId } = shopifyConst;
  const refreshToken = useGetStorage(_CSR_TOKEN_REFRESHTOKEN);
  const body = new URLSearchParams();
  // body.append(
  //   'grant_type',
  //   'urn:ietf:params:oauth:grant-type:token-exchange',
  // );
  body.append('client_id', clientId);
  body.append('grant_type', 'refresh_token');
  body.append('refresh_token', refreshToken);
  // body.append(
  //   'subject_token_type',
  //   'urn:ietf:params:oauth:token-type:access_token',
  // );
  // body.append('scopes', 'https://api.customers.com/auth/customer.graphql');

  const headers = {
    'content-type': 'application/x-www-form-urlencoded'
  }

  const response = await fetch(`https://shopify.com/${storeId}/auth/oauth/token`, {
    method: 'POST',
    headers: headers,
    body,
  });

  const resp = await response.json();

  return resp;
}
export async function attemptAccessTokenExchange(accessToken) {
  const { clientId, storeId } = shopifyConst;
  let customerApiClientId = '30243aa5-17c1-465a-8493-944bcc4e88aa';
  const body = new URLSearchParams();
  if(c4aOAuth2StateNew) {
    customerApiClientId = clientId
  }
  body.append(
    'grant_type',
    'urn:ietf:params:oauth:grant-type:token-exchange',
  );
  body.append('client_id', clientId);
  body.append('audience', customerApiClientId);
  body.append('subject_token', accessToken);
  body.append(
    'subject_token_type',
    'urn:ietf:params:oauth:token-type:access_token',
  );
  body.append('scopes', 'https://api.customers.com/auth/customer.graphql');

  const headers = {
    'content-type': 'application/x-www-form-urlencoded'
  }

  const response = await fetch(`https://shopify.com/${storeId}/auth/oauth/token`, {
    method: 'POST',
    headers: headers,
    body,
  });

  const resp = await response.json();

  return resp;
}

// 将shopify的accessToken 转换成 customer api 的 token
export const useCustomerApi = async (auth, query, variables = {}) => {
  try {
    const params =  {
      query,
      variables
    }
    let url = `web/iscrm-edm/shopifyApi/customerApi`
    if(c4aOAuth2StateNew) {
      url =`/api/gws-ext/customer/customerApi`
    }
    // setTimeout(() => {
    //   useCustomerApiFetch()
    // }, 5000);
    let response
    let res 
    if(c4aOAuth2StateNew) {
       res = await useCustomerApiFetch(query,variables);
      response = res;
    } else {
      res = await useScrmShopifyFetch(`${url}?endpoint=${domain}&auth=${auth}`).post(params).json();
      response = JSON.parse(res.data.value);
    }
    // 畅那边的接口只是转发api,主要为了解决跨域
    return response;
  } catch (e) {
    console.log(e);
  }
}

// 获取B2B接口 对与B2B用户返回所在companyLocation关联的Catalog中包含的产品
export const useGetCustomerProductsApi = async (auth,location,params = {}) => {
  return await useScrmShopifyFetch(`/web/iscrm-edm/shopifyApi/customerProducts?endpoint=${domain}&auth=${auth}&location=${location}`).post({
    ...params,
  }).json();
}

// 将shopify的accessToken 转换成 customer api 的 token
export const useCustomerTokenApi = async (auth) => {
  const query = `
  mutation storefrontCustomerAccessTokenCreate {
      storefrontCustomerAccessTokenCreate {
          customerAccessToken
          userErrors {
              field
              message
          }
      }
  }
  `;
  // 畅那边的接口只是转发api,主要为了解决跨域
  const res = await useCustomerApi(auth, query,{},true);
  return res;
}

// 查询b2b用户信息
export const useCustomerQueryApi = async (auth) => {
  const query = `
    query customer {
      customer {
        ...CustomerFragment
      }
    }
    ${customerFragment}
  `;
  // 畅那边的接口只是转发api,主要为了解决跨域
  let res
  if(c4aOAuth2StateNew) {
     res = await useCustomerApi(auth, query,{},true);
  }else {

     res = await useCustomerApi(auth, query);
  }
  return res;
}

// 组装查询参数
const buildQueryString = (params) => {
  return Object.keys(params)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&');
}

// 封装shopifyScrm请求
const useShopifyScrmFetch = async (url, param, postData) => {
  try {
    const params = {
      endpoint: domain,
      access_token: param.access_token,
      ...param
    };
    const queryString = buildQueryString(params);
    const res = await useScrmShopifyFetch(`${url}?${queryString}`).post(postData).json();
    const response = res.data.value instanceof Object ? res.data.value : JSON.parse(res.data.value);
    return response;
  } catch (e) {
    console.error(e);
  }

}

// checkout接口 加密checkout url (用于普通用户，b2b用户不用)
export const useMultipassCheckoutUrl = async (access_token, postData) => {
  const url = `/web/iscrm-edm/shopifyApi/multipass`;
  const res = await useShopifyScrmFetch(url, { access_token }, postData);
  return res;
}

// my account - my product接口（已注册产品列表）
export const useRegisteredproducts = async (access_token, email) => {
  const brand = process.env.BRAND.toLocaleUpperCase();
  const url = `/api/gws-ext/customer/registeredproducts`;
  const site = document.body.dataset.site;
  const queryObj = {
    access_token
  }
  if (isB2b) {
    Object.assign(queryObj, { b2b: 'true' })
  }
  const res = await useShopifyScrmFetch(url, queryObj, { email, site });
  const arr= res?.filter(item => item.brand === brand);
  return arr;
}

// my account - my order接口（取消订单ID)
export const useCanelOrder = async (access_token, email, orderId, isB2B) => {
  const url = `/web/iscrm-edm/shopifyApi/order/cancel`;
  const queryObj = {
    access_token
  };
  if (isB2B) {
    Object.assign(queryObj, { b2b: 'true' });
  }
  const res = await useShopifyScrmFetch(url, queryObj , { email, orderId });
  return res;
}

// my account - my order接口（订单详情）
export const useQueryOrderDetail = async (access_token, email, orderId, isB2B) => {
  const url = '/web/iscrm-edm/shopifyApi/order/detail';
  const queryObj = {
    access_token
  };
  if (isB2B) {
    Object.assign(queryObj, { b2b: 'true' });
  }
  const res = await useShopifyScrmFetch(url, queryObj, { email, orderId });
  return res;
}

/** shopify productId 转为 shopify graphQL 专用的 格式
 * @param 兼容传纯数字格式和gid格式
 * '8341535818036' √
 * 'gid://shopify/Product/8341535818036' √
 * **/

export const useFormatGraphQLProductId = (id) => {
  return `gid://shopify/Product/${String(id).match(/\d+/g)?.[0].trim()}`;
}

/** 获取shopify productId 纯数字部分， 
 * @return 纯数字
 * '8341535818036'
 * **/
export const useGetProductIdNumber = (id) => {
  return String(id).match(/\d+/g)?.[0] || '';
}
